import { Link } from "react-router-dom";
import { kuaibaoList } from "@/mocks/kuaibao";
import KuaibaoCard from "@/components/feature/KuaibaoCard";
import type { KuaibaoItem } from "@/types/kuaibao";

export default function LatestFeed() {
  const items = (kuaibaoList as KuaibaoItem[]).slice(0, 6);

  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="flex items-end justify-between gap-4 mb-8 md:mb-10">
          <div>
            <div className="inline-flex items-center gap-2 mb-3">
              <span className="w-6 h-[3px] rounded-full bg-accent-500"></span>
              <span className="font-label text-xs tracking-[0.2em] text-accent-700">
                QUICK REPORT
              </span>
            </div>
            <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950">
              吃瓜快报 · 最新速览
            </h2>
            <p className="font-label text-sm text-foreground-500 mt-2">
              一条一句话，读完就懂发生了什么
            </p>
          </div>
          <Link
            to="/kuaibao"
            className="hidden sm:inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-foreground-900 hover:bg-primary-600 text-background-50 font-label text-sm transition-colors whitespace-nowrap"
          >
            全部快报
            <i className="ri-arrow-right-line text-base leading-none"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {items.map((item, i) => (
            <KuaibaoCard key={item.slug} item={item} index={i} />
          ))}
        </div>

        <div className="mt-6 sm:hidden">
          <Link
            to="/kuaibao"
            className="inline-flex w-full items-center justify-center gap-1.5 px-4 py-2.5 rounded-md bg-foreground-900 text-background-50 font-label text-sm"
          >
            全部快报
            <i className="ri-arrow-right-line leading-none"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}